// extracted by mini-css-extract-plugin
module.exports = {"top-tips":"top-tips___2b2Qm"};